import makeNoopPlugin from "/Users/nic/Documents/dev/babel/babel/packages/babel-standalone/src/make-noop-plugin.ts"; export default makeNoopPlugin()